import { useObservable } from '@lib/common';
import { getPropertyDeviceQuery, getPropertyDeviceService } from 'app/state';
import { useEffect } from 'react';

export function usePropertyDevices(propertyId?: string) {
  const devices = useObservable(getPropertyDeviceQuery().devices);
  const pagination = useObservable(getPropertyDeviceQuery().pagination);
  const isLoading = useObservable(getPropertyDeviceQuery().isLoading);
  useEffect(() => {
    if (propertyId) getPropertyDeviceService().getDevices(propertyId, {});
  }, [propertyId]);

  return {
    devices,
    pagination,
    isLoading,
  };
}
